// src/pages/CheckoutPage.jsx
/* global fbq */
import React, { useState } from 'react';
import ShoppingCart from '../components/ShoppingCart';
import ProductImage from '../assets/images/zenzzz-jar-landing-3.png';
const CheckoutPage = () => {
    const [showOutOfStockModal, setShowOutOfStockModal] = useState(false);
    fbq('track', "initiate checkout");
    return (
        <div className="checkout-page-wrapper">
            <ShoppingCart
                productImage={ProductImage}
                isFullPage
                onOutOfStock={() => setShowOutOfStockModal(true)}
            />

            {/* NETLIFY OUT-OF-STOCK FORM MODAL */}
            {showOutOfStockModal && (
                <div className="modal-overlay" onClick={() => setShowOutOfStockModal(false)}>
                    <div className="modal" onClick={e => e.stopPropagation(e)}>
                        <h2>Almost There!</h2>
                        <p>Zenzzz is currently sold out, but we’re restocking soon.</p>
                        <p>Enter your email below and get <strong>20% OFF</strong> when we launch!</p>

                        {/* ← THIS IS THE ONLY NETLIFY FORM YOU NEED */}
                        <form
                            name="zenzzz-waitlist"
                            method="POST"
                            data-netlify="true"
                            netlify-honeypot="bot-field"
                            onSubmit={() => {
                                setTimeout(() => {
                                    alert('You’re on the list! We’ll email you at launch');
                                    setShowOutOfStockModal(false);
                                }, 800);
                            }}
                        >
                            <input type="hidden" name="form-name" value="zenzzz-waitlist" />
                            <p style={{ display: 'none' }}>
                                <label>Don’t fill this out: <input name="bot-field" /></label>
                            </p>
                            <input
                                type="email"
                                name="email"
                                placeholder="your@email.com"
                                required
                                className="waitlist-input"
                            />
                            <button type="submit" className="cta-button full-width">
                                Get 20% Off + Be First in Line
                            </button>
                        </form>

                        <button onClick={() => setShowOutOfStockModal(false)} className="close-modal">
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CheckoutPage;